/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const LayersTwoIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M18.3333 12.0833L10.2981 16.1009C10.1888 16.1556 10.1342 16.1829 10.0768 16.1937C10.026 16.2032 9.97394 16.2032 9.92316 16.1937C9.86583 16.1829 9.81117 16.1556 9.70185 16.1009L1.66666 12.0833M18.3333 7.91668L10.2981 3.89908C10.1888 3.84443 10.1342 3.8171 10.0768 3.80634C10.026 3.79681 9.97394 3.79681 9.92316 3.80634C9.86583 3.8171 9.81117 3.84443 9.70185 3.89908L1.66666 7.91668L9.70185 11.9343C9.81117 11.9889 9.86583 12.0163 9.92316 12.027C9.97394 12.0365 10.026 12.0365 10.0768 12.027C10.1342 12.0163 10.1888 11.9889 10.2981 11.9343L18.3333 7.91668Z"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
